import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { ModalContent } from '@src/shared/modal/confirm-modal/confirm-modal.type';
import { ModalService } from '@src/shared/modal/modal.service';
import { CampaignService } from '../../../../woo_services.module/CampaignService';
import { RoutingService } from '../../../../woo_services.module/RoutingService';
import { Campaign } from '../../../../woo_services.module/shared-types';

@Component({
  selector: 'cancel-campaign-button',
  template: ` <text-button icon="close-x" [disabled]="disabled" (click)="onClick()"> Avboka </text-button> `,
  standalone: false,
})
export class CancelCampaignButton {
  @Input() campaign: Campaign;
  @Input() disabled = false;

  constructor(
    private campaignService: CampaignService,
    private routingService: RoutingService,
    private modalService: ModalService,
  ) {}

  onClick = (): void => {
    if (this.disabled) {
      return;
    }

    const content = this.getDialogContent();
    this.modalService.openConfirm(content).then(
      (response) => {
        if (response.confirm) {
          this.cancelCampaign(this.campaign, response.message);
        }
      },
      () => null,
    );
  };

  private cancelCampaign = (campaign: Campaign, comment: string) => {
    const loaderModal = this.modalService.openLoader('Avbokar kampanjen');
    this.campaignService
      .cancel(campaign.id, comment)
      .then(
        (campaign: Campaign) => {
          this.modalService.openSuccess('Kampanjen har avbokats.');
          this.routingService.navigateWithReload(['/dashboard', campaign.id]);
        },
        (reason) => {
          if (!(reason instanceof HttpErrorResponse)) {
            const msg = 'Ajdå, något gick snett. Din kampanj kunde inte avbokas.';
            this.modalService.openError(msg);
          }
        },
      )
      .catch(() => {
        const msg = 'Ajdå, nånting gick snett. Testa att refresha browsern och försök igen.';
        this.modalService.openError(msg);
      })
      .finally(() => {
        loaderModal.close();
      });
  };

  private getDialogContent = (): ModalContent => {
    const content: ModalContent = {
      title: 'Avboka kampanj',
      texts: [`Är du säker på att du vill avboka <b>${this.campaign.name}</b>?`],
      comment: {
        label: 'Kommentar för avbokning',
        text: '',
        placeholder: 'Skriv en kommentar om varför du vill avboka kampanjen',
      },
      confirmLabel: 'Avboka kampanj',
      cancelLabel: 'Avbryt',
    };

    if (this.campaign.has_sent_invoices) {
      content.consent = {
        text: 'Fakturorna har redan skickats',
        label: 'Jag är medveten om att jag avbokar en kampanj med skickade fakturor.',
      };
    }
    return content;
  };
}
